import { useEffect } from 'react';
import styles from './App.module.scss';
import { useRoutes } from "./routes/routes";
import i18n from "./i18n";
import { RootState } from "./store";
import { useSelector } from "react-redux";
import { Spinner } from "./components/spinner/spinner";
import { useCheckTokenQuery } from "./api/services/authService";

export const App = () => {

  const { showSpinner} = useSelector((state: RootState) => state.mainReducer);

  const { isLoading} = useCheckTokenQuery("");

  useEffect(() => {
    i18n.changeLanguage("en");
  }, []);

  const routes = useRoutes()
  return (
    <div className={styles.container}>
      { (showSpinner || isLoading) && (<Spinner />) }
      { !isLoading && routes }
    </div>
  );
}
